import { Component, OnInit, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppService } from '../app.service';
import { GlobalService } from '../global/services/global.service';
import { generalConfigFromGlobal } from '../shared/workspace-element-context';
import { User } from '../screen-video-container/user';
import { UserService } from '../screen-video-container/user.service';
import { GtwElementsBaseUrlsModel } from '../shared/_models/gtw-elements-base-urls.model';
import { ReleaseNotesData } from './release-notes-data.model';
import { ReleaseNotesService } from './release-notes.service';
import { createGtwAppkitTextEditorConfig } from '../shared/_config/gtw-appkit-text-editor.config';

@Component({
    selector: 'gtw-release-notes',
    templateUrl: './release-notes.component.html',
    styleUrls: ['./release-notes.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ReleaseNotesComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  releaseNotesList: any = [];
  selectedNotes: any = {};
  notesBody: any = '';
  /** AppKit4 ap-text-editor (CKEditor) */
  readonly releaseNotesEditorConfig = createGtwAppkitTextEditorConfig('Please add the document');
  editorEnable: boolean = false;
  userSettings: any = [];
  access: number = 0;
  notesListSelected: boolean = false;
  enableSaveBtn: boolean = false;
  releaseNotesDataBlockEnable: boolean = false;
  reasonEIN: string = '';
  searchReleaseNotes: any;
  saveParams: any = {};
  rnKey: number = 0;
  durationInSeconds = 5;
  editedNotesBody: string = '';
  editedNotesTitle: string = '';
  reasonsEIN: any[] = [
    {
      data: [
        {
          id: 0,
          text: 'APPLD FOR',
        },
      ],
    },
  ];

  baseURLs: GtwElementsBaseUrlsModel = {
    admin: '',
    api: '',
    custom: '',
    efile: '',
    pdfEngine: '',
    bulkPdfEngine: '',
  };

  constructor(
    public gtwGlobal: GlobalService,
    public gtwApp: AppService,
    private userService: UserService,
    private releaseNotesService: ReleaseNotesService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal) as GtwElementsBaseUrlsModel;
    const u = this.gtwApp.USER_SETTINGS?.user as User | undefined;
    if (u) {
      this.userService.setUser(u);
      this.access = parseInt(u.access ? String(u.access) : '', 10) || 0;
    }
    this.init();
  }

  init() {
    this.fetchReleaseNotesList();
  }

  fetchReleaseNotesList() {
    console.log('Get Console Data Called.');
    this.releaseNotesService.getReleaseNotesList(this.baseURLs.api).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: ReleaseNotesData) => {
        if (data) {
          this.releaseNotesList = data;
          console.log(data, 'dataaaa');
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        console.log('Completed all tabs');
      }
    );
  }

  saveReleaseNoteData() {
    this.saveParams['rn_body'] = this.notesBody ?? '';

    this.saveParams.rn_title = this.editedNotesTitle;

    if (this.editorEnable == true) {
      this.saveParams.rn_key = this.selectedNotes.RN_KEY;
    }
    this.releaseNotesService.saveReleaseNotesList(this.baseURLs.api, this.saveParams).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data) => {
        if (data) {
          this.openSnackBar('Release Notes Data saved successfully.');
          this.releaseNotesDataBlockEnable = false;
          this.fetchReleaseNotesList();
          console.log(data, 'data savedddd');
        }
      },
      () => {
        this.openSnackBar('Error Occured while saving.');
        console.log('Error while saving');
      }
    );
  }

  selectNotes(selectedItem: any) {
    this.releaseNotesDataBlockEnable = true;
    this.editorEnable = false;
    this.enableSaveBtn = false;
    this.notesListSelected = true;
    this.selectedNotes = selectedItem;
  }

  addReleaseNotes() {
    this.releaseNotesDataBlockEnable = true;
    this.editorEnable = true;
    this.enableSaveBtn = true;
    this.editedNotesTitle = '';
    this.notesBody = '';
    this.selectedNotes = {};
  }

  deleteReleaseNotes() {
    this.releaseNotesDataBlockEnable = false;
    this.rnKey = this.selectedNotes.RN_KEY;
    this.releaseNotesService.deleteReleaseNotesList(this.baseURLs.api, this.rnKey).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data) => {
        if (data) {
          this.openSnackBar('Release Notes Deleted successfully.');
          this.releaseNotesDataBlockEnable = false;
          this.fetchReleaseNotesList();
          console.log(data, 'data deleted');
        }
      },
      () => {
        this.openSnackBar('Error Occured while Deleting.');
        console.log('Error while deleting');
      }
    );
  }

  changeNotesBody(event: any) {
    this.editedNotesBody = event;
  }

  editNotes() {
    this.editorEnable = true;
    this.enableSaveBtn = true;
    this.editedNotesTitle = this.selectedNotes.RN_TITLE;
    this.notesBody = this.selectedNotes.RN_BODY;
  }

  private openSnackBar(message: string) {
    this._snackBar.open(message, '', {
      duration: this.durationInSeconds * 1000,
    });
  }
}
